// Text-link blue for Results (row "Show explanation", KPI "See breakdown").
// #0b6fa8 is 5.4:1 on white, so it meets WCAG AA for small text; the brand
// #0696D7 (3.3:1) doesn't.
export const RESULTS_LINK_COLOR = '#0b6fa8';
